module.exports = __webpack_public_path__ + "img/abstractBanner.15ad96a0.png";